import {
  canPmUpdate,
  canWriteOrders,
  canWriteSaleProducts,
} from '../../../utils/permissions';
import { Divider } from 'antd';
import { Icon } from '../../../components/icon/icon';
import { Segmented } from 'antd';
import ButtonSecondaryMedium from '../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import ButtonSecondaryMediumApprove from '../../../components/common/ButtonSecondary/ButtonSecondaryMediumApprove';
import ButtonSecondaryMediumDecline from '../../../components/common/ButtonSecondary/ButtonSecondaryMediumDecline';
import ButtonSecondarySmall from '../../../components/common/ButtonSecondary/ButtonSecondarySmall';
import ButtonIconOutlineSmall from '../../../components/common/ButtonIconOutline/ButtonIconOutlineSmall';
import Tag from '../../../components/common/Tag/Tag';
import { CardDetailProduct } from '../../../components/card/CardDetailProduct/CardDetailProduct';
import { useCallback, useEffect, useMemo, useState } from 'react';
import ModalCreateSpecialProduct from './ModalCreateSpecialProduct';
import ModalUpdateSpecialProduct from './ModalUpdateSpecialProduct';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, fetchCart } from '../../../store/actions/room.action';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils/string/cn.utils';
import {
  fetchSpecialProducts,
  pmUpdateSaleProduct,
} from '../../../store/actions/sale-product.action';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { reloadSpecialProducts } from '../../../store/reducers/sale-product.reducer';
import { openMessageSuccess } from '../../../components/common/Message/openMessageSuccess';
import { openMessageError } from '../../../components/common/Message/openMessageError';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';
import ButtonIconGhostSmall from '../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import DropdownComponent from '../../../components/common/DropdownComponent/DropdownComponent';
import i18next from 'i18next';
import SwitchComponent from '../../../components/common/SwitchComponent/SwitchComponent';
import { Form } from 'antd';
import DatePickerComponent from '../../../components/common/DatePickerComponent/DatePickerComponent';
import { fetchDetailedUserAdmin } from '../../../store/actions/admin.user.action';

const DetailUserPage = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openCreateSpecialProduct, setOpenCreateSpecialProduct] =
    useState(false);

  const { user } = useSelector(state => state.auth);
  const { cart } = useSelector(state => state.room);
  const { specialProducts } = useSelector(state => state.saleProduct);
  const {
    detail: { data: userDetail },
  } = useSelector(state => state.adminUser);

  const offsetParam = searchParams.get('offset') ?? 0;
  const limitParam = searchParams.get('limit') ?? 100;
  const customerEmail = useMemo(() => {
    return userDetail?.email;
  }, [userDetail]);
  // const customerEmailParam = searchParams.get('email') ?? '';

  const updateSearchParams = ({ key, value }) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(key, value);
    if (key !== 'offset') {
      newSearchParams.set('offset', 0);
    }
    setSearchParams(newSearchParams);
  };

  const options = [
    [
      {
        value: '1',
        label: t('Current cart'),
      },
      // {
      //   value: '2',
      //   label: 'Thông tin chung',
      // },
      // {
      //   value: '3',
      //   label: 'Lịch sử',
      // },
    ],
  ];

  const items = [
    {
      key: 'vi',

      label: (
        <div
          className="flex items-center py-4 px-8 grow self-stretch"
          style={{ gap: '8px' }}
        >
          <img src="/assets/icons/VI.svg" />
          <span className="text-label-medium">{t('Vietnamese')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('vi');
      },
    },
    {
      key: 'en',

      label: (
        <div
          className="flex items-center py-4 px-8 grow self-stretch"
          style={{ gap: '8px' }}
        >
          <img src="/assets/icons/US.svg" />
          <span className="text-label-medium">{t('English')}</span>
        </div>
      ),
      onClick: () => {
        i18next.changeLanguage('en');
      },
    },
  ];

  const reloadData = useCallback(() => {
    dispatch(
      fetchSpecialProducts({
        offset: offsetParam,
        limit: limitParam,
        outsideStatus: 0,
        designFor: customerEmail?.trim() === '' ? null : customerEmail?.trim(),
        isOutside: true,
        status: 'all',
      })
    );
    if (customerEmail?.trim() !== '') {
      dispatch(
        fetchCart({
          countryCode: country_code,
          customerEmail:
            customerEmail?.trim() === '' ? null : customerEmail?.trim(),
        })
      );
    }
  }, [offsetParam, limitParam, customerEmail]);

  useEffect(() => {
    // reloadSpecialProducts();
    if (customerEmail) {
      dispatch(reloadSpecialProducts());
    }
  }, [offsetParam, limitParam, customerEmail]);

  useEffect(() => {
    if (specialProducts.isNeedReloadData) {
      reloadData();
    }
  }, [specialProducts.isNeedReloadData]);

  useEffect(() => {
    if (id) {
      dispatch(fetchDetailedUserAdmin(id));
    }
  }, [id]);
  return (
    <>
      <div className="flex p-16 items-start gap-16 w-full h-full flex-col">
        <div className="flex justify-start items-center self-stretch">
          <h2
            className="text-title-medium text-black-medium cursor-pointer"
            onClick={() => navigate(-1)}
          >
            {t('Customer')}
          </h2>
          <span className="w-20 h-20 flex items-center">
            <Icon.ICNavigateNext />
          </span>
          <h2 className="text-title-medium-emphasized">
            {t('Detailed information')}
          </h2>
        </div>
        <div className="flex items-start gap-16 self-stretch overflow-hidden">
          <div className="flex w-[260px] flex-col justify-start items-start gap-8 self-stretch">
            <div className="flex p-16 flex-col grow items-start gap-24 self-stretch rounded-16 bg-fills-white rounded-[16px]">
              <div className="flex flex-col items-center gap-16 self-stretch relative">
                <div className="flex w-64 h-64 justify-center items-center aspect-square">
                  <div
                    className="w-64 h-64 overflow-hidden shrink rounded-[64px] bg-center"
                    style={{
                      background: `url(${userDetail?.avatar_url})`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'center',
                    }}
                  />
                </div>
                <div className="flex flex-col items-center gap-8 self-stretch">
                  <h2 className="text-title-medium-emphasized">
                    {userDetail?.fullname}{' '}
                  </h2>
                  <span className="text-large-label">Normal</span>
                </div>
                <ButtonIconOutlineSmall
                  icon={<Icon.ICCameraPhoto />}
                  className="absolute right-82 top-40"
                />
              </div>
              <Divider className="m-0 p-0" type="horizontal" />
              <div className="flex flex-col justify-center items-start gap-16 self-stretch">
                <div className="flex justify-between items-start self-stretch">
                  <h3 className="text-title-small-emphasized">
                    {t('Personal information')}
                  </h3>
                  <ButtonIconGhostSmall icon={<Icon.ICEdit />} />
                </div>
                <div className="flex flex-col justify-center items-start gap-4 self-stretch">
                  <div className="flex items-center gap-12">
                    <span className="flex w-18 h-18 justify-center items-center gap-18">
                      <Icon.ICPhone />
                    </span>
                    <span className="text-label-large">{t('Phone')}</span>
                  </div>
                  <span className="text-body-medium-emphasized flex self-stretch pl-30">
                    {userDetail?.phone}
                  </span>
                </div>
                <div className="flex flex-col justify-center items-start gap-4 self-stretch">
                  <div className="flex items-center gap-12">
                    <span className="flex w-18 h-18 justify-center items-center gap-18">
                      <Icon.ICMail />
                    </span>
                    <span className="text-label-large">{t('Email')}</span>
                  </div>
                  <span className="text-body-medium-emphasized flex self-stretch pl-30 truncate">
                    {userDetail?.email}
                  </span>
                </div>
                <div className="flex flex-col justify-center items-start gap-4 self-stretch">
                  <div className="flex items-center gap-12">
                    <span className="flex w-18 h-18 justify-center items-center gap-18">
                      <Icon.ICLocation />
                    </span>
                    <span className="text-label-large">{t('Address')}</span>
                  </div>
                  <span className="text-body-medium-emphasized flex self-stretch pl-30">
                    {userDetail?.address?.street}
                  </span>
                </div>
                <div className="flex flex-col justify-center items-start gap-4 self-stretch">
                  <div className="flex items-center gap-12">
                    <span className="flex w-18 h-18 justify-center items-center gap-18">
                      <Icon.ICGlobal />
                    </span>
                    <span className="text-label-large">{t('Country')}</span>
                  </div>
                  <div className="flex self-stretch pl-25">
                    {/* <DropdownComponent
                      className="justify-between text-black/80"
                      trigger={['click']}
                      containerProps={{ className: 'grow self-stretch' }}
                      menu={{
                        items: items,
                      }}
                    >
                      <span className="cursor-pointer">
                        {
                          items.find(item => item.key === i18next.language)
                            .label
                        }
                      </span>
                    </DropdownComponent> */}
                    <span className="cursor-pointer">
                      {
                        items.find(item =>
                          (item.key === userDetail?.address?.country) == null
                            ? 'vi'
                            : 'en'
                        ).label
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex p-16 flex-col items-start gap-24 self-stretch rounded-16 bg-fills-white rounded-[16px]">
              <Form
                layout="horizontal"
                colon={false}
                className="flex items-start gap-16 self-stretch"
              >
                <div className="flex flex-col justify-center items-start gap-8">
                  <div className="flex items-center gap-4 self-stretch">
                    <span className="text-title-small-emphasized">
                      {t('Project closed')}
                    </span>
                    <span className="flex w-16 h-16 justify-center items-center gap-10">
                      <Icon.ICInfoFill />
                    </span>
                  </div>
                  <div className="flex flex-col items-start gap-4 self-stretch">
                    <Form.Item
                      label={
                        <span className="text-label-medium-emphasized">
                          {t('From date')}
                        </span>
                      }
                      name={'from'}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value) return Promise.resolve();
                            else return Promise.reject(t('Cannot be empty!'));
                          },
                        },
                      ]}
                    >
                      <DatePickerComponent
                        placeholder={t('Select')}
                        className="border-none flex grow [&_.ant-picker-input_input]:!text-label-medium-emphasized p-0"
                        size="small"
                      />
                    </Form.Item>
                    <Form.Item
                      label={
                        <span className="text-label-medium">
                          {t('To date')}
                        </span>
                      }
                      name={'to'}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value) return Promise.resolve();
                            else return Promise.reject(t('Cannot be empty!'));
                          },
                        },
                      ]}
                    >
                      <DatePickerComponent
                        placeholder={t('Select')}
                        className="border-none flex grow [&_.ant-picker-input_input]:!text-label-medium-emphasized p-0"
                        size="small"
                      />
                    </Form.Item>
                  </div>
                </div>
                <Divider type="vertical" className="m-0 p-0" />
                <SwitchComponent />
              </Form>
            </div>
          </div>
          <div className="flex flex-col items-start gap-8 grow self-stretch">
            <div className="flex p-16 items-center gap-16 self-stretch rounded-[8px] bg-fills-white">
              <Segmented
                className="p-0 bg-transparent"
                options={options[0].map(item => ({
                  ...item,
                  className:
                    'text-black-medium [&_.ant-segmented-item-label]:leading-[32px] [&.ant-segmented-item-selected]:bg-primary-primaryVarient1 [&.ant-segmented-item-selected]:text-white [&.ant-segmented-item]:!shadow-none',
                  label: (
                    <span className="text-body-medium-emphasized">
                      {item.label}
                    </span>
                  ),
                }))}
              />
            </div>
            <div className="flex flex-col items-start grow self-stretch overflow-hidden">
              <div className="flex p-16 pb-8 items-center gap-16 self-stretch justify-between">
                <span className="text-title-small-emphasized">
                  {t('Product list')}
                </span>
                <ButtonSecondaryMedium
                  title={t('Add special product')}
                  posIcon={<Icon.ICAdd />}
                  disabled={!canWriteSaleProducts(user)}
                  onClick={() => setOpenCreateSpecialProduct(true)}
                />
              </div>
              <div className="flex-col p-16 pb-20 flex items-center self-stretch gap-16 justify-start grow overflow-y-auto">
                {/* <CardSpecialProduct /> */}

                <>
                  {specialProducts.data?.map((item, index) => (
                    <CardSpecialProduct item={item} key={index} />
                  ))}
                  {cart.data?.cart_items?.map((item, index) => (
                    <CardDetailProduct
                      key={index}
                      title={getValueFromString(item.product_name)}
                      icon={item.image}
                      content={
                        <>
                          <div className="flex h-24 justify-between items-center self-stretch">
                            <span className="text-body-medium text-black-medium">
                              {t('Category')}
                            </span>
                            <div className="flex items-center gap-4">
                              {item.has_special_texture ? (
                                <Tag
                                  label={
                                    <span className="text-label-medium-emphasized text-black-high">
                                      {t('Available board')}
                                    </span>
                                  }
                                  className="bg-fills-primary rounded-[4px]"
                                />
                              ) : (
                                '--'
                              )}
                            </div>
                          </div>
                          <Divider type="horizontal" className="!my-0 !px-0" />
                          {(() => {
                            return (
                              <div className="flex h-fit justify-between items-start self-stretch">
                                <span className="text-body-medium text-black-medium">
                                  {t('Size')}
                                </span>
                                <span className="text-body-medium-emphasized flex flex-col items-end justify-end">
                                  {!!item.size?.length && (
                                    <span>
                                      {t('Length')}: {item.size?.length} mm
                                    </span>
                                  )}
                                  {!!item.size?.depth && (
                                    <span>
                                      {t('Depth')}: {item.size?.depth} mm
                                    </span>
                                  )}
                                  {!!item.size?.height && (
                                    <span>
                                      {t('Height')}: {item.size?.height} mm
                                    </span>
                                  )}
                                  {!!item.size?.backsplash && (
                                    <span>
                                      {t('Backsplash')}: {item.size?.backsplash}{' '}
                                      mm
                                    </span>
                                  )}
                                  {!!item.size?.countertop && (
                                    <span>
                                      {t('Countertop')}: {item.size?.countertop}{' '}
                                      mm
                                    </span>
                                  )}
                                  {!!item.size?.base && (
                                    <span>
                                      {t('Base')}: {item.size?.base} mm
                                    </span>
                                  )}
                                  {!!item.size?.upper && (
                                    <span>
                                      {t('Upper cabinet')}: {item.size?.upper}{' '}
                                      mm
                                    </span>
                                  )}
                                </span>
                              </div>
                            );
                          })()}

                          <div className="flex h-24 justify-between items-center self-stretch">
                            <span className="text-body-medium text-black-medium">
                              {t('Note')}
                            </span>
                            <span className="text-body-medium-emphasized">
                              {item.description || '--'}
                            </span>
                          </div>
                          <Divider type="horizontal" className="!my-0 !px-0" />
                          <div className="flex h-24 justify-between items-center self-stretch">
                            <span className="text-body-large">
                              {t('Total price')}
                            </span>
                            <div className="flex items-center gap-8">
                              {item.discount_value && item.discount_type ? (
                                <Tag
                                  label={
                                    <div className="flex items-center justify-center gap-[4px]">
                                      <span className="flex w-[16px] h-[16px]">
                                        <Icon.ICPercentDiscount />
                                      </span>
                                      <span className="text-label-medium">
                                        {t('{{x}}% Off', {
                                          x:
                                            item.discount_type ===
                                            'PERCENT_DISCOUNT'
                                              ? `${item.discount_value || 0}`
                                              : `${convertForeignCurrency(item.discount_value)}`,
                                        })}
                                      </span>
                                    </div>
                                  }
                                  className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                                />
                              ) : null}

                              <div className="flex lg:gap-[8px] gap-[4px] lg:justify-center lg:items-center items-end lg:flex-row flex-col">
                                <span className="text-body-small line-through text-black-medium">
                                  {(() => {
                                    if (
                                      Number(item.price_after) !==
                                      Number(item.price_original)
                                    ) {
                                      return convertForeignCurrency(
                                        Number(item.price_original)
                                      );
                                    }
                                  })()}
                                </span>
                                <span
                                  className={cn(
                                    'truncate text-body-large font-semibold self-stretch',
                                    Number(item.price_after) !==
                                      Number(item.price_original)
                                      ? 'text-Accents-Red'
                                      : 'text-black'
                                  )}
                                >
                                  {convertForeignCurrency(
                                    (() => {
                                      if (Number(item.price_after)) {
                                        return Number(item.price_after);
                                      } else {
                                        return (
                                          (item.total_wood_price ?? 0) +
                                          (item.total_accessory_price ?? 0) +
                                          (item.total_countertop_price ?? 0) +
                                          (item.total_backsplash_price ?? 0)
                                        );
                                      }
                                    })()
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    />
                  ))}
                </>
              </div>
            </div>
          </div>
        </div>

        <ModalCreateSpecialProduct
          open={openCreateSpecialProduct}
          onClose={() => {
            setOpenCreateSpecialProduct(false);
            reloadData();
          }}
        />
      </div>
    </>
  );
};

export default DetailUserPage;

const CardSpecialProduct = ({ item }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const [openUpdateSpecialProduct, setOpenUpdateSpecialProduct] =
    useState(false);
  return (
    <>
      <div className="flex flex-col items-start gap-16 self-stretch">
        <div className="flex p-16 flex-col items-end gap-12 self-stretch rounded-[16px] bg-primary-primaryFill">
          <div className={cn('flex items-center justify-between self-stretch')}>
            <div className={cn('flex items-center gap-16')}>
              <span className="text-label-large">{t('Approve product')}:</span>
              <ButtonSecondaryMediumApprove
                posIcon={<Icon.ICCheck />}
                disabled={
                  !canPmUpdate(user) ||
                  !canWriteOrders(user) ||
                  item.outside_status !== 0
                }
                title={t('Approve to cart')}
                onClick={() => {
                  dispatch(
                    addToCart({
                      designId: item.id,
                      customerEmail: item.design_for,
                    })
                  ).then(action => {
                    // API chỉ cho nhân viên có orders:write thêm vào giỏ người khác, thiếu quyền sẽ trả lỗi
                    if (!action.payload?.data) {
                      openMessageError({ content: t('Failed') });
                      return;
                    }
                    openMessageSuccess({
                      content: t('Product added to cart'),
                    });
                    dispatch(reloadSpecialProducts());
                  });
                }}
              />
              <ButtonSecondaryMediumDecline
                posIcon={<Icon.ICClose />}
                disabled={!canPmUpdate(user) || item.outside_status !== 0}
                title={t('Reject')}
                onClick={() => {
                  const formData = new FormData();
                  formData.append('is_active', false);
                  dispatch(
                    pmUpdateSaleProduct({
                      id: item.id,
                      data: {
                        is_active: false,
                      },
                    })
                  ).then(() => {
                    dispatch(reloadSpecialProducts());
                  });
                }}
              />
              {/* <span className="text-title-small-emphasized">
                {item.design_for}
              </span> */}
            </div>
            <ButtonSecondarySmall
              title={t('Edit')}
              posIcon={<Icon.ICEdit />}
              disabled={!canWriteSaleProducts(user)}
              onClick={() => setOpenUpdateSpecialProduct(item)}
            />
          </div>
          <CardDetailProduct
            title={getValueFromString(item.name)}
            icon={item.thumbnail_url}
            content={
              <>
                <div className="flex h-24 justify-between items-center self-stretch">
                  <span className="text-body-medium text-black-medium">
                    {t('Category')}
                  </span>
                  <div className="flex items-center gap-4">
                    <Tag
                      label={
                        <span className="text-label-medium-emphasized text-black-high">
                          {t('Add special product')}
                        </span>
                      }
                      className="bg-fills-primary rounded-[4px]"
                    />
                    {item.has_special_texture ? (
                      <Tag
                        label={
                          <span className="text-label-medium-emphasized text-black-high">
                            {t('Available board')}
                          </span>
                        }
                        className="bg-fills-primary rounded-[4px]"
                      />
                    ) : null}
                  </div>
                </div>
                <Divider type="horizontal" className="!my-0 !px-0" />
                <div className="flex h-fit justify-between items-start self-stretch">
                  <span className="text-body-medium text-black-medium">
                    {t('Size')}
                  </span>
                  <span className="text-body-medium-emphasized flex flex-col items-end justify-end">
                    {!!item.sizes?.length && (
                      <span>
                        {t('Length')}: {item.sizes?.length}
                      </span>
                    )}
                    {!!item.sizes?.depth && (
                      <span>
                        {t('Depth')}: {item.sizes?.depth}
                      </span>
                    )}
                    {!!item.sizes?.height && (
                      <span>
                        {t('Height')}: {item.sizes?.height}
                      </span>
                    )}
                    {!!item.sizes?.backsplash && (
                      <span>
                        {t('Backsplash length')}: {item.sizes?.backsplash}
                      </span>
                    )}
                    {!!item.sizes?.countertop && (
                      <span>
                        {t('Countertop length')}: {item.sizes?.countertop}
                      </span>
                    )}
                    {!!item.sizes?.base && (
                      <span>
                        {t('Lower cabinet length')}: {item.sizes?.base}
                      </span>
                    )}
                    {!!item.sizes?.upper && (
                      <span>
                        {t('Upper cabinet length')}: {item.sizes?.upper}
                      </span>
                    )}
                    {(() => {
                      return (
                        `${item.sizes?.length}x${item.sizes?.depth}x${item.sizes?.height} mm` ||
                        '--'
                      );
                    })()}
                  </span>
                </div>
                <div className="flex h-24 justify-between items-center self-stretch">
                  <span className="text-body-medium text-black-medium">
                    {t('Note')}
                  </span>
                  <span className="text-body-medium-emphasized">
                    {item.description || '--'}
                  </span>
                </div>
                <Divider type="horizontal" className="!my-0 !px-0" />
                <div className="flex h-24 justify-between items-center self-stretch">
                  <span className="text-body-large">{t('Total price')}</span>
                  <div className="flex items-center gap-8">
                    {item.discount_value && item.discount_type ? (
                      <Tag
                        label={
                          <div className="flex items-center justify-center gap-[4px]">
                            <span className="flex w-[16px] h-[16px]">
                              <Icon.ICPercentDiscount />
                            </span>
                            <span className="text-label-medium">
                              {t('{{x}}% Off', {
                                x:
                                  item.discount_type === 'PERCENT_DISCOUNT'
                                    ? `${item.discount_value || 0}`
                                    : `${convertForeignCurrency(item.discount_value)}`,
                              })}
                            </span>
                          </div>
                        }
                        className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                      />
                    ) : null}

                    <div className="flex lg:gap-[8px] gap-[4px] lg:justify-center lg:items-center items-end lg:flex-row flex-col">
                      <span className="text-body-small line-through text-black-medium">
                        {(() => {
                          if (
                            Number(item.price_after) !==
                            Number(item.price_original)
                          ) {
                            return convertForeignCurrency(
                              Number(item.price_original)
                            );
                          }
                        })()}
                      </span>
                      <span
                        className={cn(
                          'truncate text-body-large font-semibold self-stretch',
                          Number(item.price_after) !==
                            Number(item.price_original)
                            ? 'text-Accents-Red'
                            : 'text-black'
                        )}
                      >
                        {convertForeignCurrency(
                          (() => {
                            if (Number(item.price_after)) {
                              return Number(item.price_after);
                            } else {
                              return (
                                (item.total_wood_price ?? 0) +
                                (item.total_accessory_price ?? 0) +
                                (item.total_countertop_price ?? 0) +
                                (item.total_backsplash_price ?? 0)
                              );
                            }
                          })()
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            }
          />
          <div
            className={cn(
              'flex p-8 items-center gap-8 self-stretch rounded-[4px] border-[1px] border-solid border-outline-warning-primary bg-Accents-orange-fill',
              Number(item.price_after) && 'hidden'
            )}
          >
            <span className="flex w-20 h-20 text-Accents-orange text-center">
              <Icon.ICWarning />
            </span>
            <span className="text-label-large-emphasized text-black-high">
              {t('Product has no price yet')}
            </span>
            <span className="text-body-medium text-black-high">
              {t('You need to add a price for this product to approve it')}
            </span>
          </div>
        </div>
      </div>
      {openUpdateSpecialProduct && (
        <ModalUpdateSpecialProduct
          open={openUpdateSpecialProduct}
          onClose={() => {
            setOpenUpdateSpecialProduct();
            dispatch(reloadSpecialProducts());
          }}
        />
      )}
    </>
  );
};
